// extracted by mini-css-extract-plugin
export default {"MONTH":"ncYPR9","month":"ncYPR9","DAY":"YPBjTt","day":"YPBjTt","YEAR":"kymDr1","year":"kymDr1","fields":"QOGxh9","mobile":"glrf20"};